export default __webpack_public_path__ + "e97fca7aa7b09ddf4f541f656c1483ea.svg";